const BASE = {
  'admin.group_moderation.action_note_required': 'Add a moderation note before taking this action.',
  'admin.group_moderation.archive_room': 'Archive Room',
  'admin.group_moderation.audit_title': 'Audit trail',
  'admin.group_moderation.decision_note_placeholder': 'Decision note (required for final actions).',
  'admin.group_moderation.dismiss': 'Dismiss report',
  'admin.group_moderation.reopen': 'Reopen review',
  'admin.group_moderation.resolve': 'Resolve',
  'admin.group_moderation.start_review': 'Start review',
  'admin.group_moderation.state.dismissed': 'Dismissed',
  'admin.group_moderation.state.resolved': 'Resolved',
  'admin.group_moderation.state.submitted': 'Submitted',
  'admin.group_moderation.state.under_review': 'Under review',
  'notifications.rooms.title': 'Rooms',
  'rooms.info.add_description': 'Add description',
  'rooms.info.approve': 'Approve',
  'rooms.info.archive': 'Archive Room',
  'rooms.info.archive_body': 'The Room will be hidden from discovery and My rooms, and notifications will be muted. Members Chat remains available from Archived Rooms.',
  'rooms.info.archive_error': 'Room could not be archived',
  'rooms.info.archive_title': 'Archive Room?',
  'rooms.archive.empty.hint': 'Rooms you archive remain available here.',
  'rooms.archive.empty.title': 'No archived Rooms',
  'rooms.archive.navigation': 'Archived Rooms',
  'rooms.archive.restore': 'Restore Room',
  'rooms.archive.restored': 'Room unarchived.',
  'rooms.archive.section.hint': 'Hidden from discovery and My rooms. Open an archived Room here.',
  'rooms.archive.section.title': 'Archived Rooms',
  'rooms.archive.state.hint': 'This Room is restricted and Members Chat is unavailable.',
  'rooms.archive.state.title': 'This Room is archived',
  'rooms.info.cancel': 'Cancel',
  'rooms.info.category': 'Category',
  'rooms.info.change_image': 'Change Room image',
  'rooms.info.closed_hint': 'Visible to everyone; membership needs approval.',
  'rooms.info.closed_room': 'Closed Room',
  'rooms.info.close': 'Close',
  'rooms.info.crop_safe_area': 'Keep important details inside the dashed frame.',
  'rooms.info.crop_title': 'Crop Room image',
  'rooms.info.decline': 'Decline',
  'rooms.info.delete_image': 'Delete image',
  'rooms.info.delete_image_body': 'The Room will use its placeholder image until a new image is added.',
  'rooms.info.delete_image_error': 'Room image could not be deleted',
  'rooms.info.delete_image_title': 'Delete Room image?',
  'rooms.info.delete_on_leave_confirm': 'Delete Room and leave',
  'rooms.info.delete_on_leave_title': 'Delete Room?',
  'rooms.info.description': 'Description',
  'rooms.info.dismiss_as_admin': 'Dismiss as Room admin',
  'rooms.info.edit_description': 'Edit Room description',
  'rooms.info.edit_image': 'Edit Room image',
  'rooms.info.edit_name': 'Edit Room name',
  'rooms.info.enable_support': 'Enable support',
  'rooms.info.enable_support_hint': 'Allow recurring support for this Room.',
  'rooms.info.enabled': 'Enabled',
  'rooms.info.holder': 'Room holder',
  'rooms.info.image_error': 'Choose an image smaller than 8 MB.',
  'rooms.info.image_deleted': 'Room image removed.',
  'rooms.info.invite_link': 'Room invite link',
  'rooms.info.join_requests': 'Join requests',
  'rooms.info.join_requests_hint': 'Review people waiting to participate in this Room.',
  'rooms.info.join_room': 'Join Room',
  'rooms.info.leave': 'Leave Room',
  'rooms.info.leave_room': 'Leave Room',
  'rooms.info.last_member_delete_on_leave_body': 'You are the last active member. Leaving will permanently delete this public Room, including its encrypted messages and files. This cannot be undone.',
  'rooms.info.loading': 'Loading…',
  'rooms.info.make_admin': 'Make Room admin',
  'rooms.info.make_owner': 'Make Room owner',
  'rooms.info.message_member': 'Message',
  'rooms.info.members': 'Members',
  'rooms.info.monthly_support': 'Monthly support (NOK)',
  'rooms.info.mute_hint': 'Messages remain available in Members Chat.',
  'rooms.info.mute_notifications': 'Mute Room notifications',
  'rooms.info.mute_room': 'Mute Room',
  'rooms.info.name': 'Room name',
  'rooms.info.no_requests': 'No pending requests.',
  'rooms.info.not_enabled': 'Not enabled',
  'rooms.info.open_hint': 'Everyone can read. Join to participate.',
  'rooms.info.open_room': 'Open Room',
  'rooms.info.owner': 'Room owner',
  'rooms.info.owner_delete_on_leave_body': 'You created this public Room. Leaving will permanently delete it for all {count} active members, including its encrypted messages and files. This cannot be undone.',
  'rooms.info.payout_automatic': 'Automatic via Stripe',
  'rooms.info.payout_manual': 'Manual via Nettgrav',
  'rooms.info.payout_mode': 'Payout mode',
  'rooms.info.people': 'People in Room',
  'rooms.info.price_error': 'Monthly support must be between 49 and 499 NOK.',
  'rooms.info.private_hint': 'Only invited members can find and open it.',
  'rooms.info.private_room': 'Private Room',
  'rooms.info.remove_member': 'Remove from Room',
  'rooms.info.report': 'Report',
  'rooms.info.report_body': 'A report will be sent to Nettgrav moderation for review.',
  'rooms.info.report_room': 'Report Room',
  'rooms.info.previous_report_status': 'Your latest report',
  'rooms.info.report_abuse': 'Harassment or abuse',
  'rooms.info.report_already_submitted': 'You already have an active report for this Room.',
  'rooms.info.report_title': 'Report Room?',
  'rooms.info.report_details': 'Details (optional)',
  'rooms.info.report_details_hint': 'Add context that will help moderation review this report.',
  'rooms.info.report_decision_note': 'Moderation note: {note}',
  'rooms.info.report_illegal': 'Illegal content',
  'rooms.info.report_impersonation': 'Impersonation',
  'rooms.info.report_other': 'Other',
  'rooms.info.report_privacy': 'Privacy violation',
  'rooms.info.report_privacy_note': 'Your report is private and is not shown to Room members.',
  'rooms.info.report_reason': 'Reason',
  'rooms.info.report_received': 'Report received',
  'rooms.info.report_spam': 'Spam or scam',
  'rooms.info.report_status': 'Report status',
  'rooms.info.report_status_hint': 'Nettgrav moderation is reviewing this report.',
  'rooms.info.report_status_value': 'Status: {status}',
  'rooms.info.reported': 'Room reported.',
  'rooms.info.restore_error': 'Room could not be restored',
  'rooms.info.request_join': 'Request to join',
  'rooms.info.request_pending': 'Request pending',
  'rooms.info.requested_access': 'Requested access',
  'rooms.info.requests': 'Requests',
  'rooms.info.requests_load_error': 'Room requests could not be loaded.',
  'rooms.info.room': 'Room',
  'rooms.info.save': 'Save changes',
  'rooms.info.saved': 'Room settings saved.',
  'rooms.info.settings': 'Room settings',
  'rooms.info.settings_hint': 'Changes apply only to this Room and do not alter Messenger groups.',
  'rooms.info.settings_short': 'Settings',
  'rooms.info.support': 'Support',
  'rooms.info.submit_report': 'Submit report',
  'rooms.info.unmute_room': 'Unmute Room',
  'rooms.info.unarchive': 'Unarchive Room',
  'rooms.info.visibility': 'Visibility',
  'rooms.visibility.public': 'Open',
  'rooms.visibility.closed': 'Closed',
  'rooms.visibility.private': 'Private',
};

export const ROOM_INFO_TRANSLATIONS = {
  ENG: BASE,
  NOR: {
    ...BASE,
    'notifications.rooms.title': 'Rom',
    'rooms.info.approve': 'Godkjenn',
    'rooms.info.archive': 'Arkiver rom',
    'rooms.info.archive_title': 'Arkivere rommet?',
    'rooms.info.category': 'Kategori',
    'rooms.info.change_image': 'Endre rombilde',
    'rooms.info.crop_title': 'Beskjær rombildet',
    'rooms.info.decline': 'Avslå',
    'rooms.info.delete_on_leave_confirm': 'Slett rommet og forlat',
    'rooms.info.delete_on_leave_title': 'Slette rommet?',
    'rooms.info.description': 'Beskrivelse',
    'rooms.info.enabled': 'Aktivert',
    'rooms.info.holder': 'Romholder',
    'rooms.info.join_requests': 'Forespørsler om medlemskap',
    'rooms.info.join_room': 'Bli med i rommet',
    'rooms.info.leave_room': 'Forlat rommet',
    'rooms.info.last_member_delete_on_leave_body': 'Du er det siste aktive medlemmet. Hvis du forlater rommet, slettes dette offentlige rommet permanent, inkludert krypterte meldinger og filer. Dette kan ikke angres.',
    'rooms.info.loading': 'Laster…',
    'rooms.info.members': 'Medlemmer',
    'rooms.info.mute_notifications': 'Slå av romvarsler',
    'rooms.info.mute_room': 'Demp rom',
    'rooms.info.name': 'Romnavn',
    'rooms.info.no_requests': 'Ingen ventende forespørsler.',
    'rooms.info.not_enabled': 'Ikke aktivert',
    'rooms.info.open_room': 'Åpent rom',
    'rooms.info.owner': 'Romeier',
    'rooms.info.owner_delete_on_leave_body': 'Du opprettet dette offentlige rommet. Hvis du forlater det, slettes rommet permanent for alle {count} aktive medlemmer, inkludert krypterte meldinger og filer. Dette kan ikke angres.',
    'rooms.info.people': 'Personer i rommet',
    'rooms.info.private_room': 'Privat rom',
    'rooms.info.report_room': 'Rapporter rom',
    'rooms.info.request_join': 'Be om å bli med',
    'rooms.info.request_pending': 'Forespørsel venter',
    'rooms.info.requests': 'Forespørsler',
    'rooms.info.room': 'Rom',
    'rooms.info.save': 'Lagre endringer',
    'rooms.info.settings': 'Rominnstillinger',
    'rooms.info.settings_short': 'Innstillinger',
    'rooms.info.support': 'Støtte',
    'rooms.info.unmute_room': 'Slå på romlyd',
    'rooms.info.visibility': 'Synlighet',
    'rooms.visibility.public': 'Åpent',
    'rooms.visibility.closed': 'Lukket',
    'rooms.visibility.private': 'Privat',
  },
  SWE: {
    ...BASE,
    'notifications.rooms.title': 'Rum',
    'rooms.info.approve': 'Godkänn',
    'rooms.info.archive': 'Arkivera rum',
    'rooms.info.category': 'Kategori',
    'rooms.info.change_image': 'Ändra rumsbild',
    'rooms.info.decline': 'Avvisa',
    'rooms.info.delete_on_leave_confirm': 'Ta bort rummet och lämna',
    'rooms.info.delete_on_leave_title': 'Ta bort rummet?',
    'rooms.info.description': 'Beskrivning',
    'rooms.info.enabled': 'Aktiverat',
    'rooms.info.join_requests': 'Förfrågningar om medlemskap',
    'rooms.info.join_room': 'Gå med i rummet',
    'rooms.info.leave_room': 'Lämna rummet',
    'rooms.info.last_member_delete_on_leave_body': 'Du är den sista aktiva medlemmen. Om du lämnar tas det här offentliga rummet bort permanent, inklusive krypterade meddelanden och filer. Detta går inte att ångra.',
    'rooms.info.loading': 'Laddar…',
    'rooms.info.members': 'Medlemmar',
    'rooms.info.name': 'Rumsnamn',
    'rooms.info.owner_delete_on_leave_body': 'Du skapade det här offentliga rummet. Om du lämnar tas rummet bort permanent för alla {count} aktiva medlemmar, inklusive krypterade meddelanden och filer. Detta går inte att ångra.',
    'rooms.info.no_requests': 'Inga väntande förfrågningar.',
    'rooms.info.people': 'Personer i rummet',
    'rooms.info.report_room': 'Rapportera rum',
    'rooms.info.request_pending': 'Förfrågan väntar',
    'rooms.info.requests': 'Förfrågningar',
    'rooms.info.room': 'Rum',
    'rooms.info.save': 'Spara ändringar',
    'rooms.info.settings': 'Rumsinställningar',
    'rooms.info.settings_short': 'Inställningar',
    'rooms.info.visibility': 'Synlighet',
    'rooms.visibility.public': 'Öppet',
    'rooms.visibility.closed': 'Stängt',
    'rooms.visibility.private': 'Privat',
  },
  DAN: {
    ...BASE,
    'notifications.rooms.title': 'Rum',
    'rooms.info.approve': 'Godkend',
    'rooms.info.archive': 'Arkivér rum',
    'rooms.info.category': 'Kategori',
    'rooms.info.change_image': 'Skift rumbillede',
    'rooms.info.decline': 'Afvis',
    'rooms.info.delete_on_leave_confirm': 'Slet rummet og forlad',
    'rooms.info.delete_on_leave_title': 'Slet rummet?',
    'rooms.info.description': 'Beskrivelse',
    'rooms.info.enabled': 'Aktiveret',
    'rooms.info.join_requests': 'Anmodninger om medlemskab',
    'rooms.info.join_room': 'Deltag i rummet',
    'rooms.info.leave_room': 'Forlad rummet',
    'rooms.info.last_member_delete_on_leave_body': 'Du er det sidste aktive medlem. Hvis du forlader rummet, slettes dette offentlige rum permanent, inklusive krypterede beskeder og filer. Dette kan ikke fortrydes.',
    'rooms.info.loading': 'Indlæser…',
    'rooms.info.members': 'Medlemmer',
    'rooms.info.name': 'Rumnavn',
    'rooms.info.owner_delete_on_leave_body': 'Du oprettede dette offentlige rum. Hvis du forlader det, slettes rummet permanent for alle {count} aktive medlemmer, inklusive krypterede beskeder og filer. Dette kan ikke fortrydes.',
    'rooms.info.no_requests': 'Ingen afventende anmodninger.',
    'rooms.info.people': 'Personer i rummet',
    'rooms.info.report_room': 'Rapportér rum',
    'rooms.info.request_pending': 'Anmodning afventer',
    'rooms.info.requests': 'Anmodninger',
    'rooms.info.room': 'Rum',
    'rooms.info.save': 'Gem ændringer',
    'rooms.info.settings': 'Rumindstillinger',
    'rooms.info.settings_short': 'Indstillinger',
    'rooms.info.visibility': 'Synlighed',
    'rooms.visibility.public': 'Åbent',
    'rooms.visibility.closed': 'Lukket',
    'rooms.visibility.private': 'Privat',
  },
  FIN: {
    ...BASE,
    'notifications.rooms.title': 'Huoneet',
    'rooms.info.approve': 'Hyväksy',
    'rooms.info.archive': 'Arkistoi huone',
    'rooms.info.category': 'Luokka',
    'rooms.info.change_image': 'Vaihda huoneen kuva',
    'rooms.info.decline': 'Hylkää',
    'rooms.info.delete_on_leave_confirm': 'Poista huone ja poistu',
    'rooms.info.delete_on_leave_title': 'Poistetaanko huone?',
    'rooms.info.description': 'Kuvaus',
    'rooms.info.enabled': 'Käytössä',
    'rooms.info.join_requests': 'Liittymispyynnöt',
    'rooms.info.join_room': 'Liity huoneeseen',
    'rooms.info.leave_room': 'Poistu huoneesta',
    'rooms.info.last_member_delete_on_leave_body': 'Olet viimeinen aktiivinen jäsen. Poistuminen poistaa tämän julkisen huoneen sekä sen salatut viestit ja tiedostot pysyvästi. Tätä ei voi perua.',
    'rooms.info.loading': 'Ladataan…',
    'rooms.info.members': 'Jäsenet',
    'rooms.info.name': 'Huoneen nimi',
    'rooms.info.owner_delete_on_leave_body': 'Loit tämän julkisen huoneen. Poistuminen poistaa huoneen pysyvästi kaikilta {count} aktiiviselta jäseneltä sekä salatut viestit ja tiedostot. Tätä ei voi perua.',
    'rooms.info.no_requests': 'Ei odottavia pyyntöjä.',
    'rooms.info.people': 'Huoneen ihmiset',
    'rooms.info.report_room': 'Ilmoita huoneesta',
    'rooms.info.request_pending': 'Pyyntö odottaa',
    'rooms.info.requests': 'Pyynnöt',
    'rooms.info.room': 'Huone',
    'rooms.info.save': 'Tallenna muutokset',
    'rooms.info.settings': 'Huoneen asetukset',
    'rooms.info.settings_short': 'Asetukset',
    'rooms.info.visibility': 'Näkyvyys',
    'rooms.visibility.public': 'Avoin',
    'rooms.visibility.closed': 'Suljettu',
    'rooms.visibility.private': 'Yksityinen',
  },
};
